import dayjs from 'dayjs';
import { IStation } from 'app/shared/model/station.model';
import { IUser } from 'app/shared/model/user.model';
import { SessionStatus } from 'app/shared/model/enumerations/session-status.model';

export interface ISession {
  id?: number;
  status?: keyof typeof SessionStatus;
  startDateTime?: dayjs.Dayjs;
  endDateTime?: dayjs.Dayjs | null;
  station?: IStation | null;
  operator?: IUser | null;
}

export const defaultValue: Readonly<ISession> = {};
